import api from 'api/axiosInstance';
import type { Card } from 'types/transactions.types';

const getCards = (): Promise<Card[]> =>
  api.get('/v2/accountable-banking/cards').then(({ data }) => data);

export default getCards;
